import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';


const Drp_DocSettingUsedIn = forwardRef((props, ref) => {


    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(-1);
    const [IsDrp, setIsDrp] = React.useState(-1);
    const _Onchange = (value) => {
        props.onChange(value == null ? -1 : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id, isDrp = 1) {
            var temp = [];
            setIsDrp(isDrp);

            temp.push({
                Id: -1,
                Title: 'هیچکدام',
            },
                {
                    Id: 1,
                    Title: "اسناد فروش محصول / خدمات",
                },
                {
                    Id: 2,
                    Title: "اسناد رسید پرداخت",
                },
                {
                    Id: 3,
                    Title: "اسناد رسید دریافت",
                },
                {
                    Id: 4,
                    Title: "اسناد عمومی",
                },
                {
                    Id: 5,
                    Title: "اسناد انبار",
                },
                {
                    Id: 6,
                    Title: "اسناد مالیات و عوارض",
                },
                {
                    Id: 7,
                    Title: "اسناد خزانه",
                },
                {
                    Id: 8,
                    Title: "اسناد انتظامی",
                }

            )
            if (isDrp == 1) {
                setId(id)
                props.onChange(id == null ? -1 : id, id == null ? "" : temp.find(x => x.Id == id).Title)
                setList(temp);

            }
            else if(isDrp==0) {
                props.onSubmit(temp)

            }



        },

    }))



    return (
        <>
            {IsDrp == 1 ?
                <rsuite.SelectPicker
                    data={List}
                    valueKey="Id"
                    labelKey="Title"
                    className='w-100p'
                    placeholder="انتخاب کنید..."
                    value={Id}
                    onChange={(value) => _Onchange(value)}

                />
                :
                <></>
            }
        </>



    )
});

export default Drp_DocSettingUsedIn;